<template>
  <div>
    <!-- Footer -->
    <!-- <footer class="content-footer footer bg-footer-theme">
      <div class="container-xxl">
        <div
          class="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column"
        >
          <div class="text-body">
            ©2025
            <a href="https://ssradius.com" target="_blank" class="footer-link"
              >Super Speed Radius</a
            >
          </div>
          <div class="d-none d-lg-inline-block">
            <a href="#" target="_blank" class="footer-link me-4">{{
              $t("navbar.terms_of_use")
            }}</a>

            <a
              href="#"
              target="_blank"
              class="footer-link d-none d-sm-inline-block"
              >{{ $t("navbar.privacy_policy") }}</a
            >
          </div>
        </div>
      </div>
    </footer> -->
    <!-- / Footer -->
  </div>
</template>
<script>
export default {
  name: "Footer",
};
</script>
